import api from "../services/support.api";
import {LoadingState} from "./constants";
import Vue from "vue";
import reportingApi from "@/services/reporting.api";
import {dateToLocaleTimeDateString} from "@/helpers/dateHelper";

export default {
    namespaced: true,
    state: {
        clients: [],
        loadingState: LoadingState.EMPTY,
        clientsHealthScores: {
            data: [],
            state: LoadingState.EMPTY,
        }
    },
    mutations: {
        setClient(state, payload) {
          Vue.set(state.clients, payload.index, payload.client);
        },
        setClients(state, clients) {
            state.clients = clients;
        },
        setDoNotStoreBadEmailLeadsByClient(state, payload) {
            const client = state.clients[payload.clientIndex];
            client.doNotStoreBadEmailLeads = payload.doNotStoreBadEmailLeads;
            Vue.set(state.clients, payload.clientIndex, client);
        },
        setLoadingState(state, loadingState) {
            state.loadingState = loadingState;
        },
        updateClientSatisfactionLevel(state, payload) {
            const client = state.clients[payload.index];
            client.satisfactionLevel = payload.satisfactionLevel;
            client.satisfactionLevelLastUpdated = payload.dateUpdated;
            Vue.set(state.clients, payload.index, client);
        },
        updateClientsHealthScore(state, payload) {
            state.clientsHealthScores = {
                ...state.clientsHealthScores,
                ...payload,
            }
            if (payload.data) {
                const ratingsClientIds = payload.data.map(healthScore => healthScore.clientId);
                state.clients = state.clients.map((client) => {
                    if (ratingsClientIds.includes(client.clientId)) {
                        const rating = payload.data.find(rating => rating.clientId === client.clientId);
                        return {
                            ...client,
                            systemScore: rating.score,
                            codeWorking: rating.codeWorking,
                            reportDate: dateToLocaleTimeDateString(rating.createdDateTimeUTC),
                            recentEventsCount: rating.recentEventsCount,
                        }
                    }
                    return client;
                })
            }
        },
    },
    getters: {
        getClientByClientId: (state) => (clientId) => state.clients.find((client) => client.clientId === clientId),
    },
    actions: {
        SET_CLIENT({state, commit}, client) {
            const clientIndex = state.clients.map((c) => c.clientId).indexOf(client.clientId);

            if (clientIndex > -1) {
                const payload = {
                    index: clientIndex,
                    client
                }

                commit('setClient', payload);
            }
        },
        async fetchClients({commit}) {
            commit('setLoadingState', LoadingState.LOADING);
            try {
                const clients = await api.getClientList();
                commit('setClients', clients.map((client) => ({ ...client, doNotStoreBadEmailLeads: null })));
                commit('setLoadingState', LoadingState.LOADED);
            } catch (error) {
                commit('setLoadingState', LoadingState.FAILED);
            }
        },
        async setClientDoNotStoreBadEmailLeadsFilter({commit, state}, payload) {
            const clientIndex = state.clients.map((client) => client.clientId).indexOf(payload.clientId);
            if (clientIndex > -1) {
                commit('setDoNotStoreBadEmailLeadsByClient', {clientIndex, doNotStoreBadEmailLeads: payload.doNotStoreBadEmailLeads});
            }
        },
        async updateSatisfactionLevel({commit, state}, payload) {
            const clientIndex = state.clients.map((client) => client.clientId).indexOf(payload.clientId);

            if (clientIndex > -1) {
                commit('updateClientSatisfactionLevel', {
                    ...payload,
                    index: clientIndex
                });
            }
        },
        async fetchClientsHealthScore({commit}) {
            commit('updateClientsHealthScore', {state: LoadingState.LOADING});
            try {
                const ratings = await reportingApi.getClientsLatestHealthScore();
                commit('updateClientsHealthScore', {state: LoadingState.LOADED, data: ratings})
            } catch (error) {
                commit('updateClientsHealthScore', {state: LoadingState.FAILED});
            }
        },
    }
}
